import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center container mx-auto w-full lg:max-h-screen py-10 bg-transparent" }
const _hoisted_2 = { class: "flex flex-col gap-5 lg:w-9/12" }
const _hoisted_3 = ["initial", "enter"]
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = { class: "flex justify-center flex-wrap gap-10" }
const _hoisted_6 = ["initial", "enter"]
const _hoisted_7 = { class: "flex flex-col justify-center items-center p-4" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = { class: "w-full p-6 pt-4" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["initial", "enter"]
const _hoisted_14 = { class: "mb-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "“Ajuda...”", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "px-2 md:px-20",
        initial: _ctx.initialMotion,
        enter: _ctx.enterMotion
      }, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Como funciona?", en: "How it works" })), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Conheça as principais funcionalidades que você vai ter no curso:",
              en: "Discover the main features you will have in the course:",
            })), 1)
      ], 8, _hoisted_3)), [
        [_directive_motion]
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardData, (item, i) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "min-w-[350px] w-[40%] min-h-[400px] border-b-4 border-h-primary-500 shadow-lg rounded-lg bg-white mt-2",
            initial: _ctx.initialMotion,
            enter: _ctx.enterMotion.getEnterMotion((i + 1) * 200),
            key: i
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: item.image,
                alt: item.title,
                class: "w-[84px] mt-4"
              }, null, 8, _hoisted_8),
              _createElementVNode("h5", _hoisted_9, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (e, i) => {
                  return (_openBlock(), _createElementBlock("ul", {
                    class: "list-disc",
                    key: i
                  }, [
                    _createElementVNode("li", _hoisted_11, [
                      _createElementVNode("p", { innerHTML: e }, null, 8, _hoisted_12)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ], 8, _hoisted_6)), [
            [_directive_motion]
          ])
        }), 128))
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "mb-10 px-2 md:px-20",
        initial: _ctx.initialMotion,
        enter: _ctx.enterMotion.getEnterMotion(600)
      }, [
        _createElementVNode("p", _hoisted_14, [
          _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
              pt: "Lembre-se qualquer dúvida no curso use o termo ",
              en: "To talk to him, say something like:",
            })) + " ", 1),
          _hoisted_15,
          _createTextVNode(". ")
        ]),
        (!_ctx.hiddenButton)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCloseFirstTimeCourse())),
              class: "btn-primary btn-sm h-8 w-[200px]",
              label: 
            _ctx.$t('labels.generic', {
              pt: 'Iniciar o curso',
              en: 'Start the course',
            })
          
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_13)), [
        [_directive_motion]
      ])
    ])
  ]))
}